export default __webpack_public_path__ + "static/media/Provider_clinics.c9f4e12e.svg";